export default {
  name: 'Slim Banner Bottom Call To Action',
  htmlId: 'slimBannerBottomCTA',
};
